export default __webpack_public_path__ + "static/media/fa-solid_server.161bb4d3.svg";